<template>
    <div class="box" style="
        height: 960px;
        min-width: 1300px;"
         id="app">
        <div class="back-parent">
        <div class="back">
        </div>
        </div>
        <div class="login-flexbox">
            <div class="login-box">
                <div class="login-img">
                    <img class="app_img" :src="form.flg?require('@/assets/stgUpload/img_stg.png'):require('@/assets/stgUpload/img_benfan.png')">  
                    <div class="logo-login">
                        <img src="@/assets/logo.png">
                        <div>
                            <div class="logo-cn-login">职能达</div>
                            <div class="logo-en-login">ZHINENGDA</div>
                        </div>
                    </div>
                    <div class="login_img">
                       <img src="@/assets/login_img.jpg">
                    </div>
                </div>
                <div class="login-form">
                    <div class="login-form-box">
                        <div class="title">职能达后台管理系统</div>
                        <div class="input-form">
                            <div class="input-box">
                                <img src="../../assets/login_user.png">
                                <input class="effect-2 account" type="text" placeholder="请输入手机号/账号"
                                    v-model="form.username"
                                >
                                <span class="focus-border"></span>
                            </div>
                            <div class="input-box" style="margin-top: 30px;">
                                <img src="../../assets/login_password.png">
                                <input class="effect-2 password" type="password" placeholder="请输入密码"
                                    v-model="form.password"
                                >
                                <span class="focus-border"></span>
                            </div>
                        </div>
                        <BBtnPrimary class="submit" btn-txt="登录" :clicked="submit"></BBtnPrimary>
                        
                    </div>
                    
                </div>
            </div>
        </div>
        <div class="login-flexbox11">
                {{fullYear}} {{copyright}}  <a href="https://beian.miit.gov.cn/" class="mourse_in" style="text-decoration:none;color: #333333;">蜀ICP备2021005802号-1</a>
        </div>
    </div>
</template>

<script>
    import { login,getVisitAddressType } from '@/api/login'

    import BBtnPrimary from "../../components2/BBtnPrimary";
    import Vue from "vue";

    export default {
        name: 'Login',
        components: {BBtnPrimary},
        data() {
            return {
                form: {
                    flg: false,
                    username: "",
                    password: "",
                    client: "web",
                },
                fullYear: '© ' + new Date().getFullYear(),
                copyright:'四川北方新宇科技有限公司',
            };
        },
        watch: {
            $route: {
                handler: function (route) {
                    this.redirect = route.query && route.query.redirect
                },
                immediate: true,
            },
        },
        created() {
            this.getImg();
        },
        methods: {
            async getImg () {
                const data = await getVisitAddressType()
                console.log("getImg()=",data)
                if (data !== null && data !== '') {
                    if (data === 'stg') {
                        this.form.flg = true
                    } 
                }
            },
            async submit () {
                try {
                    const data = await login(this.form)
                    if (data!= null && data.code === 0) {
                        // let routerPath = '/home'
                        // this.$router.push({ path: routerPath }).catch((error) => {
                        //     console.info(error)
                        // })

                        if(data.data.privilegeDtoList.length === 0){
                            Vue.prototype.$valertbar.show("无可访问页面，请联系管理员。");
                            return;
                        }

                        const loginId = data.data.loginId
                        const accessToken = data.data.accessToken
                        const userName = data.data.userName
                        const userNameAlias = data.data.userNameAlias
                        const userId = data.data.userId
                        const roleType = data.data.roleType
                        const orgId = data.data.orgId
                        sessionStorage.setItem('loginId', loginId)
                        sessionStorage.setItem('accessToken', accessToken)
                        sessionStorage.setItem('userName', userName)
                        sessionStorage.setItem('userNameAlias', userNameAlias)
                        sessionStorage.setItem('menu', JSON.stringify(data.data.privilegeDtoList))
                        sessionStorage.setItem('userId', userId)
                        sessionStorage.setItem('roleType', roleType)
                        sessionStorage.setItem('orgId', orgId)
                        let routerPath =
                            this.redirect === '/404' || this.redirect === '/401'
                                ? '/'
                                : this.redirect
                        if (typeof (this.routerPath) === 'undefined') {
                            routerPath = '/';
                        }
                        // eslint-disable-next-line handle-callback-err
                        this.$router.push({ path: routerPath }).catch((error) => {
                            console.log(error)
                        })
                    } else if (data!= null && data.code !== 0) {
                        Vue.prototype.$valertbar.show(data.msg);
                    }
                } catch (e) {
                    console.log(e)
                }
            },
        },

        mounted() {
            let self = this
            let form = document.getElementsByClassName("login-form")[0];
            form.addEventListener("keyup", function(event) {
                if (event.keyCode === 13) {
                    event.preventDefault();
                    self.submit();
                }
            });
            if(sessionStorage.getItem("httpErrorMsg") !== null){
                Vue.prototype.$valertbar.show(sessionStorage.getItem("httpErrorMsg"));
                sessionStorage.removeItem("httpErrorMsg");
            }
        }
    };
</script>

<style>
    * {
        margin: 0;
        padding: 0;
        font-family: Source Han Sans CN;
        font-weight: 400;
    }

    html {
        /*overflow: hidden;*/
        height: 100%;
    }

    body {
        height: 100%;
    }

    .box {
        height: 100%;
        overflow: hidden;
    }

    .back-parent {
        position: absolute;
        width: 100%;
        height: 100%;
        overflow: hidden;
        z-index: -1;
    }

    .back {
        position: absolute;
        background: #0295CC;
        height: 1200px;
        width: 2500px;
        top: -700px;
        left: -500px;
        -webkit-transform: rotate(-15deg);
        -moz-transform: rotate(-15deg);
        -o-transform: rotate(-15deg);
        transform: rotate(-15deg);
        overflow: hidden;
        z-index: -1;
    }

    .login-flexbox {
        display: flex;
        height: 100%;
        justify-content: center;
        align-items: center;
        z-index: 1;
    }
    .login-flexbox11 {
        z-index: 1;
        position: relative;
        width: 100%;
        text-align: center;
        left: 0;
        bottom: 8%;
    }

    .login-box {
        display: flex;
        height: calc(100% - 300px);
        width: calc(100% - 500px);
        background: #FDFDFD;
        box-shadow: 0px 3px 40px 0px rgba(171, 167, 167, 0.35);
    }

    .login-img {
        position: relative;
        width: 43%;
        height: 100%;
        overflow: hidden;
    }

    .login-form {
        display: flex;
        width: 57%;
        justify-content: center;
        align-items: center;
    }

    .login-img img {
        width: 100%;
        height: 100%;
    }

    .login-form-box {
        width: 400px;
        height: 450px;
        background: white;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
    }

    .title {
        width: 343px;
        font-size: 36px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #3F3F3F;
        line-height: 58px;
    }

    :focus {
        outline: none;
    }

    .effect-2 {
        border: 0;
        padding: 7px 0;
        /*border-bottom: 1px solid #ccc;*/
    }

    .effect-2 ~ .focus-border {
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 0;
        height: 2px;
        background: #0171A3;
        transition: 0.4s;
    }

    .effect-2:focus ~ .focus-border {
        width: 100%;
        transition: 0.4s;
        left: 0;
    }

    input[type="text"] {
        color: #333;
        width: 100%;
        box-sizing: border-box;
        letter-spacing: 1px;
    }

    .input-box {
        position: relative;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #ccc;
    }

    .input-form {
        display: flex;
        flex-direction: column;
    }

    .input-box img {
        width: 25px;
        height: 25px;
        margin: 20px;
    }

    .logo-login {
        position: absolute;
        color: white;
        margin-left: 43px;
        margin-top: 50px;
        display: flex;
        align-items: center;
        z-index: 999;
    }

    .logo-login div {
        margin-left: 10px;
    }

    .logo-login img {
        width: 80px;
        height: 71px;
    }

    .logo-cn-login {
        font-size: 28px;
    }

    .logo-en-login {
        font-family: High Tower Text;
        font-size: 12px;
    }

    .mourse_in:hover {
        color: blue !important;
    }

    .login_img {
        position: relative;
    }

    .app_img {
        position: absolute;
        bottom: 1em;
        left: 1em;
        width: 20% !important;
        height: auto !important;
        z-index: 1000;
    }
  
  @media (max-width: 1279px) {
    .back-parent {
        position: absolute;
        height: 960px;
        width: 1300px;
        overflow: hidden;
        z-index: -1;
    }
  }
  @media (max-width: 1682px) {
    .login_img {
        position: relative;
        height: 660px;
    }
  }
  @media (min-width: 2071px) {
    .back {
        position: absolute;
        background: #0295CC;
        height: 1200px;
        width: 3500px;
        top: -700px;
        left: -500px;
        -webkit-transform: rotate(-15deg);
        -moz-transform: rotate(-15deg);
        -o-transform: rotate(-15deg);
        transform: rotate(-15deg);
        overflow: hidden;
        z-index: -1;
    }
  }
  
</style>
